/**
 * Reference marketplace % (legacy ~8% assumption).
 * For standard sellers, QuickAsyst % of list = quick_cut + (BASELINE − selected marketplace %),
 * floored at 0. Lower marketplace % → more to QuickAsyst; higher → less (symmetric vs baseline).
 */
export const BASELINE_MARKETPLACE_PERCENT = 8;

/** Logitix / marketplace commission rates (% of list price), keyed by admin dashboard label. */
export const MARKETPLACE_FEE_PERCENT: Record<string, number> = {
  AXS: 8,
  Gametime: 8,
  GoTickets: 8,
  SeatGeek: 6,
  StubHub: 6,
  "Ticket Evolution": 4,
  Ticketmaster: 6,
  TicketNetwork: 8,
  TickPick: 8,
  "Vivid Seats": 9,
};

export const MARKETPLACE_OPTIONS = Object.keys(MARKETPLACE_FEE_PERCENT).sort((a, b) =>
  a.localeCompare(b),
);

export function getMarketplaceFeePercent(marketplaceName: string): number | null {
  const key = marketplaceName?.trim();
  if (!key) return null;
  const pct = MARKETPLACE_FEE_PERCENT[key];
  return pct === undefined ? null : pct;
}
